import { Link } from "react-router";
import { Modal } from "../Dialog";
import { Button } from "../Button";
import { trackReviewLocationClick } from "@/utils/analytics";
import { PendingSurvey, ReviewLocation } from "./feedback";

export default function ThankYou({
  buildingName,
  open,
  onClose,
  reviewLocations,
  leaseId,
  followUpSurvey,
}: {
  buildingName: string;
  open: boolean;
  onClose: () => void;
  reviewLocations: ReviewLocation[];
  leaseId?: number | string;
  followUpSurvey?: PendingSurvey | null;
}) {
  return (
    <Modal open={open} onClose={onClose}>
      <div className="flex flex-col items-center">
        <h2 className="text-lg font-bold">Thank you!</h2>
        <p className="mt-2">
          Your living experience is important to us. Thanks for your feedback.
        </p>
        <img src="/thumbs_up.png" className="h-48 py-8" />
        {reviewLocations.length > 0 && (
          <>
            <p className="mt-2">
              Seems you are having a great time living at {buildingName}! Would
              you like to share this review on the following site? That’ll be
              really appreciated!
            </p>
            <div className="mt-4">
              <ReviewLocationLinks reviewLocations={reviewLocations} />
            </div>
          </>
        )}
        {followUpSurvey && leaseId && (
          <FollowUpSurveyPrompt leaseId={leaseId} survey={followUpSurvey} />
        )}
        <div className="flex justify-end items-end mt-4">
          <Button
            size="small"
            color="primary"
            onClick={onClose}
            className="w-full md:w-auto"
          >
            Done
          </Button>
        </div>
      </div>
    </Modal>
  );
}

function FollowUpSurveyPrompt({
  leaseId,
  survey,
}: {
  leaseId: number | string;
  survey: PendingSurvey;
}) {
  const { surveyId, title, questionCount } = survey;

  if (!surveyId) {
    return null;
  }

  return (
    <div className="w-full mt-4 pt-4 border-t border-gray-200 text-center">
      <p className="font-medium">{title || "We have a quick survey for you"}</p>
      <p className="mt-1 text-sm text-gray-600">
        {questionCount
          ? `${questionCount} question${questionCount === 1 ? "" : "s"} — would you like to share more details?`
          : "Would you like to share more details? Take a short survey."}
      </p>
      <Link to={`/lease/${leaseId}/surveys/${surveyId}`} className="block w-full mt-3">
        <Button color="secondary" className="w-full">
          Take Survey
        </Button>
      </Link>
    </div>
  );
}

export function ReviewLocationLinks({
  reviewLocations,
}: {
  reviewLocations: ReviewLocation[];
}) {
  if (reviewLocations && reviewLocations.length > 0) {
    const reviewLocation = reviewLocations[0];

    return (
      <div className="py-4">
        <a
          href={reviewLocation.url}
          onClick={() => {
            trackReviewLocationClick();
          }}
          target="_blank"
          rel="noreferrer"
          className="text-red-400"
          style={{
            textDecoration: "none",
            fontSize: 16,
          }}
        >
          Leave the review on {reviewLocation.name}
        </a>
      </div>
    );
  }

  return null;
}
